<template>

    <div>
        <!-- <div class="d-inline-block align-left">
            <h5>Bioceres Semillas</h5>
            <img  class="d-inline-block align-top mr-1" style="max-width: 100px;"
                             src="../../../assets/images/logoFoot.png" alt="Wiagro Dashboard">
       </div>
    -->
        
    <div class="d-flex align-items-center justify-content-between">

        <language-selector class="mr-4"/>
        <events-bell/>
        <el-menu default-active="1" class="el-menu-demo" mode="horizontal" text-color="#3D5170"
                 active-text-color="#3D5170">
            <el-submenu index="1">
                <template slot="title">
                    <i class="fas fa-user-circle fa-2x mr-2"/>
                    <span class="d-none d-md-inline-block ">{{userName}}</span>
                </template>
                <el-menu-item index="1-1" @click="goToProfile">
                    <i class="fas fa-user px-2"/>
                    <span>{{$t('NAVBAR.PROFILE')}}</span>
                </el-menu-item>
                <el-menu-item index="1-2" class="text-danger" @click="logout">
                    <i class="material-icons text-danger px-2">&#xE879;</i>
                    <span>{{$t('NAVBAR.LOGOUT')}}</span>
                </el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
    </div>
</template>
<script>
    import api from "../../../utils/api/api";
    import routesNames from "../../../utils/router/routesNames";
    import mutations from "../../../utils/store/mutations";
    import eventsBell from "../../common/eventsBell";
    import languageSelector from "../../common/languageSelector";

    export default {
        name: "NavbarNav",
        components: {
            "events-bell": eventsBell,
            "language-selector": languageSelector
        },
        computed: {
            userName: function () {
                const name = this.$store.state.user.name;
                return (name === undefined || name === "") ? this.$t("NAVBAR.ADMIN") : name;
            }
        },
        methods: {
            goToProfile: function () {
                this.$router.push({name: routesNames.USER_PROFILE})
            },
            logout: function () {
                api.logout(this.$store.state.user.id, this.$store.state.token).catch(reason => {
                    console.error("Error en el logout", reason);
                }).finally(() => {
                    this.$store.commit(mutations.DELETE_STORE);
                    this.$router.push({name: routesNames.LOGIN})
                })
            }
        },

    }

</script>
<style lang="scss">

    .nav-link:hover {
        cursor: pointer;
    }

    .left-auto {
        left: auto;
    }

    .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
        border-bottom: none;
        color: #3D5170;
    }

    .el-menu-item:hover {
        background-color: #EAEAEA !important;
    }
</style>
